
import FormatterService from '@/service/FormatterService'
import { finAgentUrlPrefix, finAgentMenuType } from "@/constants/finAgent";

export default {
    name: 'FinAgentMessage',
    props: {
        isUserMessage: {
            type: Boolean,
            default: false,
        },
        content: {
            type: String,
            default: '',
        },
        isAgentTyping: {
            type: Boolean,
            default: false,
        },
        widgets: {
            type: Array,
            default: () => [],
        },
        isAtBottom: {
            type: Boolean,
            default: true,
        },
        created: {
            type: String,
            default: ''
        }
    },
    emits: ['update-widgets-data', 'update-menu-state'],

    computed: {
        hasDetailsInformationWidgets() {
            return this.widgets && this.widgets.length > 0
        },
        detailsIcon() {
            return this.$vuetify.theme.dark ?
                require('@/assets/icons/finagent-details-icon-dark.svg') :
                require('@/assets/icons/finagent-details-icon-light.svg');
        },
        finAgentAvatar() {
            return this.$vuetify.theme.dark ?
                require('@/assets/icons/fin-agent-answer-avatar-dark.svg') :
                require('@/assets/icons/fin-agent-answer-avatar-light.svg');
        },
        showDetailsInformationButton() {
            return !this.isUserMessage && this.hasDetailsInformationWidgets && this.$isFinAgentPage(this.$route);
        }
    },

    created() {
        this.format = new FormatterService();
    },

    methods: {
        handleClickSeeDetails() {
            this.$emit('update-widgets-data', this.widgets);
        },
        getFinagentDataByUrl(url = '') {
            const emptyResult = { type: null, data: null };

            try {
                const withoutProtocol = url.replace(finAgentUrlPrefix, '');
                const [type, queryString] = withoutProtocol.split('?');
                const data = {};

                if (queryString) {
                    const searchParams = new URLSearchParams(queryString);
                    for (const [key, value] of searchParams.entries()) {
                        data[key] = value;
                    }
                }

                if (type === finAgentMenuType.stock) {
                    return {
                        type,
                        data
                    };
                }

                return emptyResult;
            } catch (_) {
                return emptyResult;
            }
        },
        handleClickMessageContent(event) {
            if (event.target.tagName === 'A' && event.target.href.startsWith(finAgentUrlPrefix)) {
                event.preventDefault();

                const rect = event.target.getBoundingClientRect();
                const viewportWidth = window.innerWidth;
                const viewportHeight = window.innerHeight;
                const x = rect.x < viewportWidth / 2 ? rect.x + 470 : rect.x ;
                const y = rect.y < viewportHeight / 2 ? rect.y + 20 : rect.y - 470;

                const { type, data } = this.getFinagentDataByUrl(event.target.href);
                if (!type || !data) return;
                this.$emit('update-menu-state', { x, y, visible: true, type, data } );
            }
        }
    }
}
